export const calcFields = [
  'density',
  'queue',
  'curspeed',
  'vehonlink',
  'inflow'
]
